module.exports = __webpack_public_path__ + "img/67.58229732.jpg";